import Vue from 'vue'
import Vuex from 'vuex'

import * as players from './modules/players'
import * as regions from './modules/regions'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',
  modules: {
    players: { namespaced: true, ...players},
    regions: { namespaced: true, ...regions}
  },
})
